/* Warenkorb-Drawer: Klick auf „20 € Rabatt“.
   1. Drawer schließen und das Klaviyo-Popup öffnen (ID aus den Theme-Einstellungen, Standard ULVKR4).
   2. Erscheint es nicht (z. B. Targeting), zum eingebetteten Formular RZ5LVm auf der Seite scrollen.
   3. Gibt es auf der Seite keins, zur PDP wechseln; dort scrollt dieses Script nach dem Laden hin. */
(function () {
  if (window.haCartTrustInit) return;
  window.haCartTrustInit = true;

  var FORM_SELECTOR = 'div[class^="klaviyo-form-"]';
  var PARAM = 'ha_newsletter';

  function findForm() {
    var forms = document.querySelectorAll(FORM_SELECTOR);
    for (var i = 0; i < forms.length; i++) {
      if (!forms[i].closest('cart-drawer')) return forms[i];
    }
    return null;
  }

  function scrollToForm(form) {
    var top = form.getBoundingClientRect().top + window.pageYOffset - 80;
    window.scrollTo({ top: top, behavior: 'smooth' });
    var input = form.querySelector('input[type="email"]');
    if (input) setTimeout(function () { input.focus({ preventScroll: true }); }, 700);
  }

  function track() {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) {
        Shopify.analytics.publish('cart_newsletter_click', { path: location.pathname });
      }
    } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ha-newsletter]');
    if (!btn) return;
    e.preventDefault();
    track();
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.close === 'function') drawer.close();
    var popupId = btn.getAttribute('data-ha-newsletter');
    if (popupId) {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', popupId]);
    }
    setTimeout(function () {
      var popup = popupId && document.querySelector('form[data-testid="klaviyo-form-' + popupId + '"]');
      if (popup && popup.getBoundingClientRect().height > 0) return;
      fallback();
    }, popupId ? 1800 : 350);
  });

  function fallback() {
    var form = findForm();
    if (form) { scrollToForm(form); return; }
    var url = (window.haCartTrustProductUrl || '/products/das-90-tage-hautbalance-system');
    window.location.href = url + (url.indexOf('?') > -1 ? '&' : '?') + PARAM + '=1';
  }

  function onLoad() {
    if (location.search.indexOf(PARAM + '=1') === -1) return;
    var tries = 0;
    (function wait() {
      var form = findForm();
      if (form && form.children.length) { scrollToForm(form); return; }
      if (++tries < 20) setTimeout(wait, 250);
      else if (form) scrollToForm(form);
    })();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onLoad);
  else onLoad();
})();
